import { gql, useMutation } from "@apollo/client";
import Cookies from "js-cookie";
import { useContext } from "react";
import { MenuContext } from "src/contexts/menu-context/MenuContext";
import { UserContext } from "src/contexts/UserContext";
import useAAA from "src/utils/hook/base/useAAA";
import useErrorHandling from "src/utils/hook/base/useErrorHandling";
import useRequestConfig from "src/utils/hook/base/useRequestConfig";

//Schema definition
const refreshToken = gql`
  mutation refreshToken($refreshToken: String!) {
    refreshToken(refreshToken: $refreshToken) {
      statusCode
      message
      accessToken
      wso2Expire
      wso2Token
      accessExpireTime
    }
  }
`;

const useNewToken = () => {
  const {clearUserData}=useAAA();
  const {errorHandling}=useErrorHandling();
  const {requestConfig}=useRequestConfig();
  const [mutate] = useMutation(refreshToken,requestConfig({module:"AVC_AAA",Microservice:""}));
  const {setIsLoggedin}=useContext(UserContext)
  const NewToken = () => {
    const Refresh = Cookies.get("pqwlmakxmcer");
    mutate({
      variables: { refreshToken: Refresh },
      onCompleted: (data) => {
        if (data.refreshToken.statusCode === 1200) {
          Cookies.set("Access", data.refreshToken.accessToken);
          Cookies.set("poijwejsmvcsd", data.refreshToken.accessExpireTime);
          Cookies.set("nmzbxcbashsaoisd", data.refreshToken.wso2Token);
          Cookies.set("amdehfdmwhjwqlk", data.refreshToken.wso2Expire);
          setIsLoggedin(true);
        } else {
          // clearUserData(); 
          // clearAll();
          // setNewTabItems([]);
          // setNewTabContent([]);
          // setTab(null);
          // setIsLoggedin(false);
          clearUserData();
          //Navigate("/login");
        }
      },
      onError: (error) => {
      // clearUserData(); 
      // clearAll();
      // setNewTabItems([]);
      // setNewTabContent([]);
      // setTab(null);
      // setIsLoggedin(false);
      clearUserData();
      errorHandling(error);
      //Navigate("/login");
      },
    });
  };
  return { NewToken };
};
export default useNewToken;
